// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__sx0Lc","logo":"MainNavigation_logo__CrSlm","nav":"MainNavigation_nav__U+VO1","active":"MainNavigation_active__jR0d1"};